/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_3_TitleInputs */

const et_portfolio_project_3_title = /** @type {(inputs: Portfolio_Project_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-poe müük kasvas 40% esimese 30 päevaga.`)
};

const en_portfolio_project_3_title = /** @type {(inputs: Portfolio_Project_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increased eCommerce sales by 40% in the first 30 days.`)
};

/**
* | output |
* | --- |
* | "Increased eCommerce sales by 40% in the first 30 days." |
*
* @param {Portfolio_Project_3_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_3_title = /** @type {((inputs?: Portfolio_Project_3_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_3_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_3_title(inputs)
	return en_portfolio_project_3_title(inputs)
});